import { useContext, useEffect } from "react"
import { toast } from "sonner"
import { Button } from "~/components/ui/button"
import { validateFormAnswers } from "~/lib/forms"
import { FormFillContext } from "./question-block"

export function FormPagination({
	onSubmit,
	pending,
	disabled
}: {
	onSubmit: () => void
	pending?: boolean
	disabled?: boolean
}) {
	const fill = useContext(FormFillContext)
	const pagination = fill?.pagination
	const page = pagination?.page ?? 0
	const lastPage = !pagination || page === pagination.pages.length - 1
	useEffect(() => {
		if (!pagination || !fill) return
		const errorPage = pagination.pages.findIndex((ids) =>
			ids.some((id) => fill.errors[id])
		)
		if (errorPage >= 0 && errorPage !== page) pagination.setPage(errorPage)
	}, [fill?.errors, pagination?.pages, page, pagination?.setPage])
	return (
		<div
			className={`flex items-center gap-3 ${page > 0 ? "justify-between" : "justify-end"}`}
		>
			{pagination && page > 0 && (
				<Button
					type="button"
					variant="ghost"
					disabled={pending || disabled}
					onClick={() => {
						pagination.setErrors({})
						pagination.setPage(page - 1)
					}}
				>
					Back
				</Button>
			)}
			<Button
				type="button"
				pending={pending}
				disabled={disabled}
				onClick={() => {
					if (lastPage || !pagination || !fill) return onSubmit()
					const result = validateFormAnswers(fill.fields, fill.answers)
					const errors = Object.fromEntries(
						Object.entries(result.errors).filter(
							([id]) => id === "form" || pagination.pages[page]?.includes(id)
						)
					)
					pagination.setErrors(errors)
					if (Object.keys(errors).length) {
						toast.error(
							errors.form || "Check the highlighted questions and try again."
						)
						return
					}
					pagination.setPage(page + 1)
				}}
			>
				{lastPage ? "Submit" : "Next"}
			</Button>
		</div>
	)
}
